





















import { defineComponent } from "@vue/composition-api";
import { HistoryManager } from "@/utils/history";

interface Props {
  history: HistoryManager<T>;
}

export default defineComponent<Props>({
  name: "HistoryControls",
  props: {
    history: { type: Object, required: true }
  }
});
